/* src/app/ship/pickup-location-info/pickup-location-info.component.scss */
.pickup-location-title {
  font-size: 0.75rem;
  font-style: normal;
  font-weight: 700;
  line-height: 1rem;
  white-space: nowrap;
}
.address-wrapper {
  font-size: 0.625rem;
  font-style: normal;
  font-weight: 400;
  line-height: 1.25rem;
}
.edit {
  position: absolute;
  top: 0.31rem;
  right: 0.9375rem;
  font-size: 0.625rem;
  font-style: normal;
  font-weight: 700;
  line-height: 1.25rem;
  text-decoration-line: underline;
  color: #004791;
}
.edit a {
  cursor: pointer;
}
:host(.pickup-location-info) {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  position: relative;
  padding: 0.4375rem 0.9375rem;
  border-radius: 0.25rem;
  border: 1px solid #004791;
  background: white;
  min-height: 3.125rem;
  column-gap: 0.94rem;
}
/*# sourceMappingURL=pickup-location-info.component.css.map */
